/**
 * Relevance-score badge styles — the shared color source for the "N分 (label)"
 * badge used on the Impact tab (StageBreakdown activity relevance) and the Pipeline
 * List Score column. Figma tokens; 1→3 = 弱→强 (worst→best).
 *
 * NOTE: this is the BADGE style (color + bg + label). OppPoolPanel has a SEPARATE,
 * differently-shaped relevance style (dot symbol/size, purple) for its density dots
 * — intentionally not merged here.
 */

export interface ScoreStyle {
  /** Text color. */
  color: string;
  /** Badge background. */
  bg: string;
  /** Chinese relevance label. */
  label: string;
}

/** Score → badge style, for the meaningful scores 1/2/3. */
export const RELEVANCE_STYLES: Record<1 | 2 | 3, ScoreStyle> = {
  3: { color: '#00802F', bg: '#DDF3E4', label: '强相关' }, // green
  2: { color: '#855900', bg: '#FFF3DC', label: '中相关' }, // amber
  1: { color: '#DB0000', bg: '#FEE4E2', label: '弱相关' }, // red
};

/**
 * Style for a pipeline/activity score where 0 IS a real value to display (the
 * Pipeline List Score column). Per product, **score 0 shares score 1's style**
 * (red / 弱相关) — a 0-score pipeline reads the same as a weakly-relevant one.
 * Scores outside 0..3 → undefined (render nothing). Distinct from StageBreakdown's
 * own `score >= 1 && score <= 3` gate, which treats 0 as "unscored / no badge".
 */
export function scoreStyleWithZero(score: number | undefined): ScoreStyle | undefined {
  if (score == null) return undefined;
  if (score === 0 || score === 1) return RELEVANCE_STYLES[1];
  if (score === 2) return RELEVANCE_STYLES[2];
  if (score === 3) return RELEVANCE_STYLES[3];
  return undefined;
}
